// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { RegistrarService } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Service/Registrar';
import { InstrumentConfiguration } from '@daml.js/dtc-registry/lib/Dtc/Registry/V3/Configuration/Instrument';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';

const useDisableFractionalSupportInstrumentConfiguration: () => UseMutationResult<
  void,
  string,
  {
    registrarServiceCid: ContractId<RegistrarService>;
    instrumentConfigurationCid: ContractId<InstrumentConfiguration>;
  }
> = () => {
  const ledgerApi = useLedgerApiClient();

  return useMutation({
    mutationKey: ['disableFractionalSupportInstrumentConfiguration', ledgerApi],
    mutationFn: async ({ registrarServiceCid, instrumentConfigurationCid }) => {
      return ledgerApi.disableFractionalSupportRegistryInstrumentConfiguration(
        registrarServiceCid,
        instrumentConfigurationCid,
      );
    },
    retry: false,
  });
};

export default useDisableFractionalSupportInstrumentConfiguration;
